import { Controller } from "@hotwired/stimulus"
import { advanceTask, tickCountdown, weekdayLabel } from "../helpers/conductor_clock.js"

export default class extends Controller {
  static targets = ["weekday", "progress", "square", "text", "clock"]
  static values = {
    tasks: Array,
    taskTemplate: String,
    finished: String
  }

  connect() {
    this.index = 0
    this.timer = null
    if (this.hasWeekdayTarget) this.weekdayTarget.textContent = weekdayLabel(new Date())
    this.showCurrent()
  }

  disconnect() {
    this.stop()
  }

  start() {
    if (!this.tasksValue.length || this.done) return
    this.stop()
    this.timer = window.setInterval(() => this.tick(), 1000)
  }

  pause() {
    this.stop()
  }

  restart() {
    this.stop()
    this.index = 0
    this.done = false
    this.showCurrent()
  }

  tick() {
    const task = this.tasksValue[this.index]
    if (!task) return
    const step = tickCountdown(Number(this.clockTarget.textContent))
    this.clockTarget.textContent = String(step.remaining)
    if (!step.finished) return
    const next = advanceTask(this.index, this.tasksValue.length)
    this.index = next.index
    this.done = next.done
    if (next.done) {
      this.stop()
      if (this.hasProgressTarget) this.progressTarget.textContent = this.finishedValue
      this.clockTarget.textContent = "0"
      return
    }
    this.showCurrent()
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer)
    this.timer = null
  }

  showCurrent() {
    const task = this.tasksValue[this.index]
    if (!task) return
    if (this.hasSquareTarget) this.squareTarget.textContent = String(task.square ?? "")
    if (this.hasTextTarget) this.textTarget.textContent = task.text || ""
    if (this.hasClockTarget) this.clockTarget.textContent = String(task.seconds ?? "")
    if (this.hasProgressTarget) {
      this.progressTarget.textContent = this.taskTemplateValue
        .replace("%{current}", String(this.index + 1))
        .replace("%{total}", String(this.tasksValue.length))
    }
  }
}
